import React from 'react';
import ContentCard from '../Common/ContentCard';
import { assetUrl, formatDate, toExcerpt } from '../Common/useEntries';
import { isNewPublication } from './newPublications';

/** Card for a single publication in the publications listing. */
export default function Publication({ publications }) {
    if (!publications?.fields) return null;

    const { title, slug, description, publicationmedia, publicationCategory, date } =
        publications.fields;

    return (
        <ContentCard
            title={title}
            description={toExcerpt(description, 140)}
            image={assetUrl(publicationmedia)}
            tag={publicationCategory || undefined}
            meta={[formatDate(date || publications.sys?.createdAt)]}
            badge={isNewPublication(publications) ? 'New' : undefined}
            to={`/publicationdetails/${slug}`}
            cta="View publication"
        />
    );
}
